// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"fc6d4de6","352":"e20c4371"}[chunkId] + ".chunk.js";
};